import { twJoin } from "tailwind-merge"
import React, { Fragment, useState } from "react"
import Image from "next/image"
import { TransformSectionsType, transformSections } from "./data"
import { Collapse } from "../../components/Collapse"
import { MainButton } from "@components/MainButton/MainButton"

export const TransformBlock = ({
  imageFirst,
  title,
  beforeTitle,
  description,
  linkText,
  href,
  showBlur,
  image,
  collapseItems,
}: TransformSectionsType & { showBlur?: boolean }) => {
  const [state, setState] = useState<{ openIndex?: number }>({ openIndex: undefined })

  return (
    <div className={twJoin("flex relative items-center", "flex-col", "768:flex-row", "gap-32p", "768:gap-64p")}>
      {showBlur && (
        <div
          className={twJoin(
            "absolute top-[-20%]  w-[714px] h-[714px] rounded-[714px]",
            !imageFirst ? "left-[-10%]" : "right-[-10%]",
            "blur-[180px]",
            "bg-[linear-gradient(180.73deg,_rgba(253,_177,_255,_0.3)_0.62%,_rgba(141,_138,_226,_0.3)_99.37%)]"
          )}
        />
      )}

      <div
        className={twJoin(
          "flex flex-col justify-center",
          "gap-16p",
          "768:gap-32p",
          "1024:gap-48p",
          "relative z-10",
          "w-full",
          "order-1",
          imageFirst ? "768:order-2" : "768:order-1"
        )}
      >
        <div className="flex flex-col gap-y-40p">
          <h3 className="uppercase text-13p leading-20p 1024:leading-22p 1024:text-14p font-400 text-slate-blue-600">
            {beforeTitle}
          </h3>
          {title && (
            <h3 className="text-24p leading-32p 1024:leading-40p 1024:text-32p font-600 text-neutral2-900">{title}</h3>
          )}
          {description && (
            <div className="text-14p 1024:text-20p font-400 leading-20p 1024:leading-28p text-neutral2-700">
              {description}
            </div>
          )}
          <div className={twJoin("flex flex-col gap-y-24p 1024:gap-y-32p")}>
            {collapseItems.map((item, index) => (
              <Fragment key={`${item.title}-${item.description}`}>
                <Collapse
                  className={twJoin("[&_.collapse-button]:gap-8p", "[&_.collapse-content]:pt-12p", "flex flex-col")}
                  isOpen={index === state.openIndex}
                  onToggle={() => {
                    setState((prevState) => ({
                      ...prevState,
                      openIndex: index === prevState.openIndex ? undefined : index,
                    }))
                  }}
                  title={({ isOpen }) => (
                    <h3
                      className={twJoin(
                        "text-left",
                        "text-18p leading-26p font-500",
                        "1024:text-22p 1024:leading-28p",
                        isOpen ? "text-slate-blue-600" : "text-neutral2-900"
                      )}
                    >
                      {item.title}
                    </h3>
                  )}
                  iconFunc={({ isOpen }) => (
                    <div className={twJoin("relative", "flex items-center justify-center", "w-24p h-24p")}>
                      <div className={twJoin("absolute", "w-14p h-2p bg-neutral2-900")} />
                      <div
                        className={twJoin(
                          "absolute",
                          "w-14p h-2p  transition-all",
                          isOpen ? "rotate-0 bg-slate-blue-600" : "rotate-90 bg-neutral-900"
                        )}
                      />
                    </div>
                  )}
                >
                  <span
                    className={twJoin(
                      "text-16p leading-26p font-400 text-neutral2-700",
                      "1024:text-18p 1024:leading-28p "
                    )}
                  >
                    {item.description}
                  </span>
                </Collapse>
                {collapseItems.length - 1 === index ? null : <div className={twJoin("w-full h-1p bg-neutral2-400")} />}
              </Fragment>
            ))}
          </div>
          {linkText && <div>
            <MainButton
              href={href}
              size={44}
              size1024={56}
              className={twJoin("768:inline-flex")}
            >
              {linkText}
            </MainButton>
          </div>}
        </div>
      </div>
      <div
        className={twJoin(
          "flex flex-col gap-y-48p",
          "relative z-10",
          "w-full max-w-[520px]",
          "order-2",
          imageFirst ? "768:order-1" : "768:order-2",
          "rounded-12p overflow-hidden"
        )}
      >
        <Image
          src={image}
          alt={beforeTitle}
          className={"w-full h-auto"}
          sizes="(min-width: 768px) 520px, 100vw"
        />
      </div>
    </div>
  )
}

export const TransformTimeManagement = () => (
  <section className={twJoin("p-20p", "768:p-32p", "1024:p-42p", "1440:p-120p")}>
    <h2 className={twJoin("text-center text-26p", "1024:text-44p", "font-600 text-neutral2-900 pb-64p")}>
      Traqq connects time with projects, people, and financial outcomes
    </h2>
    <div className={twJoin("flex flex-col gap-y-64p", "1280:max-w-[1200px] mx-auto")}>
      {transformSections.map((item) => (
        <TransformBlock
          key={`${item.beforeTitle}-bla`}
          showBlur={true}
          collapseItems={item.collapseItems}
          beforeTitle={item.beforeTitle}
          title={item.title}
          description={item.description}
          linkText={item.linkText}
          href={item.href}
          imageFirst={item.imageFirst}
          image={item.image}
        />
      ))}
    </div>
  </section>
)
